export const UptimeIcon = ({ size = 14, className = "" }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M12.834 7h-1.447a1.17 1.17 0 0 0-1.126.852l-1.37 4.876a.146.146 0 0 1-.28 0L5.39 1.272a.146.146 0 0 0-.28 0L3.738 6.148A1.17 1.17 0 0 1 2.62 7H1.167"
        stroke="#00c48c"
        strokeWidth="1.167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);
